import { forEach } from 'lodash'

import { batchOpacityRevealAnimation } from './shared'
import { Animation } from '@/types'

export const cardGridRevealAnimation = ({ context, reverse }: Animation) => {
  const cards = context.selector?.('[data-motion-card]')
  const heading = context.selector?.('[data-motion-heading]')

  let cardsBatchAnimation: ScrollTrigger[]
  if (cards.length > 0) {
    cardsBatchAnimation = batchOpacityRevealAnimation({
      targets: [heading, ...cards],
      reverse,
      stagger: {
        amount: 0.12
      }
    })
  }

  return () => {
    forEach(cardsBatchAnimation || [], (animation) => animation.kill())
  }
}
